import { Link } from "react-router-dom";
import { H5 } from "@blueprintjs/core";
import moment from "moment";
import "./FooterContent.scss";
import { constructPath, findRoute, RouteProps } from "routes";
import { RouteType } from "routes/types";
import { Node } from "utils/tree";

export default function FooterContent(props: RouteProps) {
  const { routes } = props;
  const omitRoutes = [findRoute(routes, "ProductIntroduction")?.data?.name, findRoute(routes, "Platform")?.data?.name];

  const renderLink = (node?: Node<RouteType>) =>
    node ? (
      <Link to={constructPath(node)}>{node.data?.description ? node.data?.description : node.data?.label}</Link>
    ) : undefined;

  return (
    <div className="footer-content">
      <div className="footer-left">
        <div className="footer__column">
          <H5>About</H5>
          <ul>
            {findRoute(routes, "About")?.children.map((c, i) => (
              <li key={c.data?.name}>{renderLink(c)}</li>
            ))}
          </ul>
        </div>

        <div className="footer__column">
          <H5>Applications</H5>
          <ul>
            {findRoute(routes, "Applications")
              ?.children.filter((c) => !omitRoutes.includes(c.data?.name))
              .slice(0, 6)
              .map((c, i) => (
                <li key={c.data?.name}>{i < 5 ? renderLink(c) : "..."}</li>
              ))}
          </ul>
        </div>

        <div className="footer__row">
          <div className="footer__column">
            <H5>Contact</H5>
            <ul>
              <li>
                <a href={`mailto:${process.env.REACT_APP_ADMIN_EMAIL}`}>{process.env.REACT_APP_ADMIN_EMAIL}</a>
              </li>
            </ul>
          </div>

          <div className="footer__column">
            <H5>Related Links</H5>
            <ul>
              <li>
                <a href="https://www.pnnl.gov/energy-storage" target="_blank" rel="noreferrer">
                  Energy Storage | PNNL
                </a>
              </li>
              <li>
                <a href="https://www.pnnl.gov/grid-storage-launchpad-pnnl" target="_blank" rel="noreferrer">
                  Grid Storage Launchpad | PNNL
                </a>
              </li>
              <li>
                <a href="https://www.pnnl.gov/ESGC-cost-performance" target="_blank" rel="noreferrer">
                  Energy Storage Cost and Performance Database | PNNL
                </a>
              </li>
              <li>
                <a href="https://energystorage.pnnl.gov/regulatoryactivities.asp" target="_blank" rel="noreferrer">
                  Energy Storage Policy Database | PNNL
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-right">
        <div className="footer-right__doe">
          <a href="https://www.energy.gov/" target="_blank" rel="noreferrer">
            <img src="images/DOE_Logo_Black.svg" alt="Department of Energy Logo" />
          </a>
        </div>
        <div className="footer-right__pnnl">
          <a href="https://www.pnnl.gov/" target="_blank" rel="noreferrer">
            <img src="images/PNNL_Vertical_Logo_Black.svg" alt="Pacific Northwest National Laboratory Logo" />
          </a>
        </div>
        <div className="footer-right__date">Last update: {moment(process.env.REACT_APP_DATE).format("MMMM YYYY")}</div>
      </div>
    </div>
  );
}
